import { createContext, useContext } from "react";

interface CartContext {
  reset: () => void;
}

export const CartContext = createContext<CartContext | null>(null);

export const useCart = () => {
  const context = useContext(CartContext);
  if (context === null) {
    throw new Error(
      "useCart must be used within a CartProvider, but no provider was found",
    );
  }

  return context;
};
